import { Box, CloseButton, Flex, Stack, Text } from '@chakra-ui/react'
import { useState } from 'react'
import DangerSign from '../../images/icons/DangerSign'
import ExclamationMark from '../../images/icons/ExclamationMark'
import HandUp from '../../images/icons/HandUp'
import MessageBubble from '../../images/icons/MessageBubble'

const BEIGE_10 = '#e3fcf3'
const BEIGE_20 = '#e3f3fc'
const BEIGE_25 = '#fce3e4'
const BLACK = '#000'
const BLUE_10 = '#2676a5'
const RED_10 = '#e35256'
const YELLOW_10 = '#f7ba07'
const CYAN_10 = '#3da07b'

export type BannerStyleTypes =
  | 'alert_info'
  | 'alert_danger'
  | 'alert_warning'
  | 'alert_success'
  | 'alerts'

interface BannerItemProps {
  bannerStyle: BannerStyleTypes
  title: string
  message: string
}

const defaultAlert = {
  bg: BEIGE_20,
  color: BLUE_10,
  icon: <MessageBubble color={BLUE_10} />,
  borderBottomColor: '#2676a5',
}

const getBannerStyle = (style: BannerStyleTypes) => {
  switch (style) {
    case 'alert_info':
      return {
        bg: BEIGE_20,
        color: BLUE_10,
        icon: <MessageBubble color={BLUE_10} />,
        borderBottomColor: '#b4d8ed',
      }
    case 'alert_danger':
      return {
        bg: BEIGE_25,
        color: RED_10,
        icon: <DangerSign color={RED_10} />,
        borderBottomColor: '#f6cbcc',
      }
    case 'alert_warning':
      return {
        bg: YELLOW_10,
        color: BLACK,
        icon: <ExclamationMark color={BLACK} />,
        borderBottomColor: '#b2b2b2',
      }
    case 'alert_success':
      return {
        bg: BEIGE_10,
        color: CYAN_10,
        icon: <HandUp color={CYAN_10} />,
        borderBottomColor: '#c0e7d8',
      }

    default:
      return defaultAlert
  }
}

const BannerItem = ({ bannerStyle = 'alert_info', title, message }: BannerItemProps) => {
  const [isOpen, setOpen] = useState(true)
  const parsedBannerStyle = getBannerStyle(bannerStyle)

  if (!isOpen) return null

  return (
    <Flex
      backgroundColor={parsedBannerStyle.bg}
      color={parsedBannerStyle.color}
      align="center"
      justify="space-between"
      padding="20px"
      borderBottom={`1px solid ${parsedBannerStyle.borderBottomColor}`}
    >
      <Stack direction="row" alignItems="center">
        <Box paddingRight="20px" marginRight={0}>
          {parsedBannerStyle.icon}
        </Box>
        <Box>
          <Text fontSize="18px" marginTop={0} marginBottom={0}>
            {title}
          </Text>
          <Text
            fontSize="14px"
            marginTop={0}
            marginBottom={0}
            dangerouslySetInnerHTML={{ __html: `${message}` }}
          />
        </Box>
      </Stack>
      <CloseButton
        color={parsedBannerStyle.color}
        background="none"
        border="none"
        _hover={{ bg: 'none' }}
        _active={{ bg: 'none' }}
        _focus={{ bg: 'none' }}
        onClick={() => setOpen(false)}
      />
    </Flex>
  )
}

export default BannerItem
